import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { canSavePastedLink, pastedLinkProblem } from '../serviceLinkEdit';
import { findItMessages as m, servicesPanelMessages } from '../servicesPanelMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for FindIt; each part uses its own slice of it */
import styles from './FindIt.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface FindItPasteProps {
  integrationType: string;
  serviceName: string;
  isSaving: boolean;
  saveFailed: boolean;
  onSave: (url: string) => void;
}

/** "Music24 cannot search YouTube Music" with the paste field (design d4 "Not searchable"). */
const FindItPasteComponent: React.FC<FindItPasteProps> = ({
  integrationType,
  serviceName,
  isSaving,
  saveFailed,
  onSave,
}) => {
  const intl = useIntl();
  const [value, setValue] = useState('');
  const problem = pastedLinkProblem(integrationType, value);
  const canSave = canSavePastedLink(integrationType, value) && !isSaving;
  return (
    <div className={styles.empty}>
      <b>{withBrandWord(intl.formatMessage(m.notSearchableTitle, { service: serviceName }))}</b>
      <p>{intl.formatMessage(m.notSearchableBody, { service: serviceName })}</p>
      <div className="d-flex gap-2 w-100">
        <Input
          type="url"
          value={value}
          invalid={problem !== null}
          aria-label={serviceName}
          placeholder={intl.formatMessage(servicesPanelMessages.pastePlaceholder, { service: serviceName })}
          onChange={(event) => setValue(event.target.value)}
        />
        <button
          type="button"
          className="btn btn-sm btn-primary"
          disabled={!canSave}
          onClick={() => onSave(value.trim())}
        >
          {intl.formatMessage(isSaving ? servicesPanelMessages.saving : servicesPanelMessages.save)}
        </button>
      </div>
      {saveFailed && <span className={styles.saveError}>{intl.formatMessage(servicesPanelMessages.saveFailed)}</span>}
    </div>
  );
};

export const FindItPaste = TypedMemo(FindItPasteComponent);
